export default __webpack_public_path__ + "static/media/multilingual.590858de.svg";